<div class="sm:grid sm:grid-cols-4 sm:gap-4 content-space">
  <div *ngFor="let post of blogPosts; let i = index" [ngClass]="{'col-span-2 first-post': i === 0}">
    <app-blog-card [blogPost]="post"></app-blog-card>
  </div>
</div>
